import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventStepUp } from '@onefootprint/request-types/dashboard';
import { Trans } from 'react-i18next';
import useSession from '@/hooks/use-session';
import Details from './components';
type StepUpEventHeaderProps = {
  data: UserTimelineEventStepUp['data'];
};
const StepUpEventHeader = t0 => {
  const $ = _c(6);
  const {
    data
  } = t0;
  const {
    ruleSetResultId
  } = data[0];
  const {
    isLive
  } = useSession();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="inline text-body-2 text-primary md:block"><Trans ns="entity-details" i18nKey={_temp} components={{
        b: <b className="text-label-2 text-primary" />
      }} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isLive || $[2] !== ruleSetResultId) {
    t2 = isLive && ruleSetResultId && <Details ruleSetResultId={ruleSetResultId} />;
    $[1] = isLive;
    $[2] = ruleSetResultId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="md:flex md:items-center md:gap-1">{t1}{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default StepUpEventHeader;
function _temp($) {
  return $.auditTrail.timeline.stepUpEvent.stepUpRequired;
}